export default __webpack_public_path__ + "static/snippet-9629293edfc0a0220fe3fdfda9f4e213.png";